import { useStores } from '@/hooks/use-stores';
import { AutoComplete, Form } from 'antd';
import { observer } from 'mobx-react-lite';
import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountSelectDropdownStyles, StyledAccountSelectContainer } from './AccountSelectFreeSolo.styles';
import {
  AccountSelectOption,
  buildAccountSelectOptions,
  handleAccountBlur,
  handleAccountChange,
  handleAccountSelect,
  initializeDisplayValue,
} from './AccountSelectFreeSolo.utils';

type Props = {
  form: ReturnType<typeof Form.useForm>[0];
};

export const AccountSelectFreeSolo: FC<Props> = observer(({ form }) => {
  const { t } = useTranslation();
  const { siteSurveyStore } = useStores();

  useEffect(() => {
    const initialValue = initializeDisplayValue(siteSurveyStore);
    if (initialValue) {
      form.setFieldValue('customerDisplayName', initialValue);
    }
  }, [form, siteSurveyStore]);

  const displayValue = Form.useWatch('customerDisplayName', form);

  const filteredOptions = useMemo(
    () => buildAccountSelectOptions(siteSurveyStore.userData, displayValue, siteSurveyStore.isLoading, t),
    [displayValue, siteSurveyStore.userData, siteSurveyStore.isLoading, t],
  );

  const handleChange = (value: string) => {
    handleAccountChange(value, form, siteSurveyStore);
  };

  const handleSelect = (option: AccountSelectOption) => {
    handleAccountSelect(option, siteSurveyStore, form);
  };

  const handleBlur = () => {
    handleAccountBlur(displayValue, form, siteSurveyStore);
  };

  return (
    <StyledAccountSelectContainer>
      <AccountSelectDropdownStyles />
      <Form.Item
        className="account-select-container"
        name="customerDisplayName"
        rules={[{ required: true, message: '' }]}
      >
        <AutoComplete
          className="account-select-freesolo"
          popupClassName="account-select-freesolo-dropdown"
          placeholder={t('Add customer name')}
          variant="filled"
          allowClear
          size="large"
          onChange={handleChange}
          onSelect={(_val, option) => handleSelect(option)}
          onBlur={handleBlur}
          options={filteredOptions}
        />
      </Form.Item>
      <Form.Item name="account" hidden />
      <Form.Item name="newCustomerName" hidden />
    </StyledAccountSelectContainer>
  );
});
